import { firebaseFirestore, firebaseStorage } from 'services/firebase';

export const getGiftsWonWithImageUrls = async snapshot => {
  const giftsPromise = await (snapshot.data().giftsWon || []).map(async giftWon => {
    let imageUrl = null;

    if (giftWon.gift && giftWon.gift.image) {
      const { image } = giftWon.gift;

      try {
        imageUrl = await firebaseStorage.ref(image).getDownloadURL();
      } catch (error) {
        imageUrl = null;
      }
    }
    return { ...giftWon, gift: { ...giftWon.gift, image: imageUrl } };
  });

  const giftsWon = await Promise.all(giftsPromise);

  return giftsWon;
};

export const setClaimOnGift = (snapshot, isClaimed, rowIndex) => {
  const giftsWon = snapshot.data().giftsWon;
  giftsWon[rowIndex].isClaimed = isClaimed;
  return giftsWon;
};

export const getWinnersWithCities = async snapshot => {
  const winnersPromises = snapshot.docs.map(async doc => {
    let city = '';
    if (doc.data().city && doc.data().city !== '') {
      const cityRef = await firebaseFirestore.collection('cities').doc(doc.data().city);
      const citySnapshot = await cityRef.get();

      if (citySnapshot.data() && citySnapshot.data().name) {
        city = citySnapshot.data().name || '';
      }
    }

    const hasClaimedGifts = doc.data().giftsWon && hasClaimedGiftsWon(doc.data().giftsWon);

    return { ...doc.data(), city, hasClaimedGifts };
  });

  const winners = await Promise.all(winnersPromises);

  return winners;
};

const hasClaimedGiftsWon = giftsWon => {
  if (giftsWon.length === 0) {
    return false;
  }

  return giftsWon.findIndex(gift => !gift.isClaimed) === -1;
};
